module.exports = __webpack_public_path__ + "img/booklist-outline.7fb0de1.svg";